import { disabledAnchor } from '@styles/vanilla-extract/utils';
import React from 'react';

import CoreSkeletonBox from '@shared/CoreSkeletonBox';

import CoreImg from '@shared/CoreImg';

import { gridClass, imgClass, imgContainerClass } from './style.css';
import CustomLink from 'src/shared/custom-link/CustomLink';

export interface NineGridPicturesItem {
	src?: string;
	link?: string;
}

export interface NineGridPicturesCardProps {
	images?: NineGridPicturesItem[];

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const NineGridPicturesCard = ({
	isLoading,
	isError,
	lackOfPermission,
	...props
}: NineGridPicturesCardProps) => {
	const images =
		lackOfPermission || isLoading || isError ? new Array(9).fill(0) : props.images ?? [];

	const getRandomImg = (idx: number) => `https://source.unsplash.com/random/?${idx}`;

	return (
		<div className={gridClass}>
			{images.map((item, idx) => {
				if (isLoading)
					return (
						<CoreSkeletonBox
							key={idx}
							_width="100%"
							_height="100%"
							delay={`${0.3 * idx}s`}
						/>
					);

				if (isError)
					return (
						<div key={idx} className={imgContainerClass}>
							<div className={imgClass}>
								<CoreImg
									src={'public/images/report/no-image.png'}
									alt={'content-image'}
									object_fit="cover"
								/>
							</div>
						</div>
					);

				return (
					<CustomLink
						key={idx}
						href={item.link ?? ''}
						target={'_blank'}
						className={disabledAnchor}
						aria-disabled={lackOfPermission || !item.link}
					>
						<div className={imgContainerClass}>
							<div className={imgClass}>
								{item.src && item.src !== '' && (
									<CoreImg
										src={lackOfPermission ? getRandomImg(idx) : item.src ?? ''}
										alt={'content-image'}
										object_fit="cover"
									/>
								)}
							</div>
						</div>
					</CustomLink>
				);
			})}
		</div>
	);
};

export default NineGridPicturesCard;
